// Message box
import { qsAll } from "scripts/data_utils/domHelpers";
export default function initMessageClose() {
  qsAll(".message-close").map(cross => {
    cross.addEventListener("click", () => cross.closest(".message-box").classList.add("-collapsed"));
  });
}